import { NgModule } from '@angular/core';
import { MeetingTypePersonalLinkDropdownComponent } from './personal-link-dropdown/meeting-type-personal-link-dropdown.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MeetingTypeLinkDropdownComponent } from './link-dropdown/meeting-type-link-dropdown.component';

@NgModule({
  imports: [CommonModule, ClipboardModule, MatIconModule, MatMenuModule, MatButtonModule, TranslateModule],
  declarations: [MeetingTypePersonalLinkDropdownComponent, MeetingTypeLinkDropdownComponent],
  exports: [MeetingTypePersonalLinkDropdownComponent],
})
export class MeetingTypeModule {}
